import { CloseOutlined } from '@ant-design/icons';
import * as Unicons from '@iconscout/react-unicons';
import { Button, DatePicker, Input, InputNumber, Progress, Select, Steps, TimePicker } from 'antd';
import 'antd/dist/antd.css';
import moment, { Moment } from 'moment';
import { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Header from '../../components/Header';
import Modal from '../../components/Modal';
import { WEEK_DAYS_ACRONYMS } from '../../constants/week-days-acronyms.constant';
import { useTurmaContext } from '../../context/TurmaContext';
import { useNotificationService } from '../../services/notification.service';
import { ICurriculoCleanDTO, IDiaSemana, INegocioUnidadeDTO, ISalaCleanDTO, IUnidadePessoaCleanDTO } from './../../models/happy-code-api.model';
import AddCurriculumHours from './components/AddCurriculumHours';
import { useFindData } from './hooks/use-find-data.hook';
import useGridFirstTime from './hooks/use-grid-first-time.hook';
import useTime from './hooks/use-time.hook';
import './style.css';

const { Option } = Select;
const { RangePicker } = DatePicker;

export const TurmasCreateStep1: React.FunctionComponent = () => {
	const { turma, setTurma, editBtnIsVisible } = useTurmaContext();
	const { Step } = Steps;
	const [isOpen, setIsOpen] = useState(false);
	const [novaHora, setNovaHora] = useState<Moment>();
	const [novaHoraFim, setNovaHoraFim] = useState<Moment>();
	const [dia, setDia] = useState<IDiaSemana>();
	const { listProfessor, listNegocios, listCurriculos, listSalas, negocioSelected, listNegocioVigenciaContrato, opcoesVigencia,listNegocioVigenciaTurma } = useFindData();
	const { onConfirmarHorario, shouldShowAddCurriculumHours, setAdicionarHorario, adicionarHorario } = useTime({ negocioSelected });
	const notification = useNotificationService();
	const grade = useGridFirstTime();
	const history = useHistory();
	const horarioFormat = 'HH:mm';
	const validaCamposObrigatorios = () => {
		const camposInvalidos = [];

		if (turma.codigo === '' || turma.codigo === undefined) camposInvalidos.push('Nome da Turma');
		if (turma.maxAlunos === 0 || turma.maxAlunos === undefined) camposInvalidos.push('Maximo Alunos');
		if (turma.curriculoNegocioId === 0 || turma.curriculoNegocioId === undefined) camposInvalidos.push('Produto');
		if (turma.curriculo?.id === 0 || turma.curriculo?.id === undefined) camposInvalidos.push('Curriculo');
		if (turma.dataInicio === undefined) camposInvalidos.push('Data inicio');
		if (turma.dataFim === undefined) camposInvalidos.push('Data fim');
		if (turma.sala?.id === 0 || turma.sala?.id === undefined) camposInvalidos.push('Sala');
		if (turma.unidadePessoa?.id === 0 || turma.unidadePessoa?.id === undefined) camposInvalidos.push('Professor');
		if (negocioSelected?.periodicidadeObrigatoria && turma?.horarios.length < negocioSelected?.periodoSemana)
			camposInvalidos.push('Horário precisa ser preenchido');

		if (camposInvalidos.length > 0) {
			notification({
				description: `Campos obrigatórios não preenchidos: ${camposInvalidos.join(', ')}`,
				type: 'warning',
				message: 'Aviso!',
			});
			return false;
		} else {
			history.push('/turmas/create/step-2');
		}
	};

	useEffect(() => {
		if (novaHora && negocioSelected?.periodicidadeObrigatoria) {
			setNovaHoraFim(novaHora.clone().add(negocioSelected?.duracaoAula, 'minutes'));
		}
	}, [novaHora]);

	useEffect(() => {
		if (negocioSelected) {
			setTurma((prev) => {
				if (!prev || !prev.horarios || prev.horarios.length === 0) return prev;
	
				return {
					...prev,
					horarios: prev.horarios.map((horario, index) => 
						index === 0 && negocioSelected.periodicidadeObrigatoria
							? {
								...horario,
								horaFim: moment(horario.horaInicio, horarioFormat)
									.add(negocioSelected.duracaoAula, 'minutes')
									.format(horarioFormat),
							} 
							: horario
					),
				};
			});
		}
	}, [negocioSelected]);

	return (
		<div className="container-fondo">
			<Header />
			<div className="progress">
				<Progress className="progress-user" percent={70} strokeLinecap="square" showInfo={false} />
			</div>
			<div className="menu-user">
				<h3>Criação de turma</h3>
				<Steps direction="vertical" current={0}>
					<Step title="Dados Básicos" />
					<Step title="Revisão" />
				</Steps>
			</div>
			<div className="franquia">
				<div className="user-row" id="row-aluno">
					<h3>Dados básicos de turma</h3>
					<div className="input-box" id="box-aluno">
						<p>
							Negócio<span id="ob">*</span>
						</p>
						<Select
							className="w-100"
							placeholder="Selecione o produto"
							allowClear
							showSearch
							optionFilterProp="children"
							defaultValue={turma?.curriculoNegocioId}
							value={turma?.curriculoNegocioId}
							onChange={(e) => {
								setTurma({ ...turma, curriculoNegocioId: e, vigencia: null });
							}}
							filterOption={(input, option) => option?.text?.toLowerCase().includes(input.toLowerCase())}
						>
							{listNegocios?.map((negocioUnidade: INegocioUnidadeDTO) => (
								<Option key={negocioUnidade.negocio.id} value={negocioUnidade.negocio.id} text={negocioUnidade.negocio.descricao}>
									{negocioUnidade.negocio.descricao}
								</Option>
							))}
						</Select>
					</div>

					<div className="input-box" id="box-aluno">
						<p>
							Curriculo<span id="ob">*</span>
						</p>
						<Select
							className="w-100"
							placeholder="Selecione um curriculo"
							allowClear
							showSearch
							optionFilterProp="children"
							defaultValue={turma.curriculo?.id}
							value={turma.curriculo?.id}
							onChange={(e) => {
								setTurma({ ...turma, curriculo: { ...turma.curriculo, id: e } });
							}}
							filterOption={(input, option) => option?.text?.toLowerCase().includes(input.toLowerCase())}
						>
							{listCurriculos &&
								listCurriculos?.map((curriculo: ICurriculoCleanDTO) => (
									<Option key={curriculo?.id} value={curriculo?.id} text={curriculo?.descricaoCurriculo}>
										{curriculo?.descricaoCurriculo}
									</Option>
								))}
						</Select>
					</div>
					<div className="input-box">
						<p>
							Nome da Turma <span id="ob">*</span>
						</p>
						<Input
							placeholder="Nome turma"
							value={turma?.codigo}
							maxLength={48}
							onChange={(e) =>
								setTurma({
									...turma,
									codigo: e.target.value,
									descricao: e.target.value,
								})
							}
						/>
					</div>
					<div className="input-box">
						<p>
							Máximo de alunos na turma<span id="ob">*</span>
						</p>
						<InputNumber
							className="w-100"
							min={0}
							defaultValue={turma.maxAlunos}
							value={turma?.maxAlunos}
							onChange={(e) => setTurma({ ...turma, maxAlunos: e })}
							placeholder="Máximo de alunos na turma"
						/>
					</div>

					<div className="inputs-box">
						<div className="input-box" id="box-aluno">
							<p>
								Sala<span id="ob">*</span>
							</p>
							<Select
								className="w-100"
								placeholder="Selecione uma sala"
								allowClear
								showSearch
								optionFilterProp="children"
								defaultValue={turma?.sala?.id}
								value={turma?.sala?.id}
								onChange={(e) => setTurma({ ...turma, sala: { ...turma.sala, id: e } })}
								filterOption={(input, option) => option?.text?.toLowerCase().includes(input.toLowerCase())}
							>
								{listSalas &&
									listSalas?.map((sala: ISalaCleanDTO) => (
										<Option key={sala.id} value={sala.id} text={sala.descricaoSala}>
											{sala.descricaoSala}
										</Option>
									))}
							</Select>
						</div>
						<div className="input-box" id="box-aluno">
							<p>
								Instrutor<span id="ob">*</span>
							</p>
							<Select
								className="w-100"
								placeholder="Selecione uma sala"
								allowClear
								showSearch
								optionFilterProp="children"
								defaultValue={turma?.unidadePessoa?.id}
								value={turma?.unidadePessoa?.id}
								onChange={(e) =>
									setTurma({
										...turma,
										unidadePessoa: { ...turma.unidadePessoa, id: e },
									})
								}
								filterOption={(input, option) => option?.text?.toLowerCase().includes(input.toLowerCase())}
							>
								{listProfessor &&
									listProfessor?.map((prof: IUnidadePessoaCleanDTO) => (
										<Option key={prof.id} value={prof.id} text={prof.pessoaNome}>
											{prof.pessoaNome}
										</Option>
									))}
							</Select>
						</div>
					</div>
					<div className="input-box">
						<p>Vigência do contrato</p>
						<span>{listNegocioVigenciaContrato?.map((info) => info.vigencia.descricao).join(', ') || 'Não informado'}</span>
					</div>
					<div className="input-box" id="box-aluno">
						<p>
							Vigência da turma<span id="ob">*</span>
						</p>
						<Select
							style={{ width: '100%' }}
							placeholder="Selecione a vigência"
							defaultValue={turma?.vigencia?.id}
							value={turma?.vigencia?.id}
							onChange={(e) => {
								const vigenciaEncontrada = listNegocioVigenciaTurma?.find((v) => v?.vigencia?.id === e);
								setTurma({
									...turma,
									vigencia: { ...turma?.vigencia, id: e, dias: vigenciaEncontrada?.vigencia?.dias || 0 },
								});
							}}
						>
							{opcoesVigencia}
						</Select>
					</div>
					<div className="inputs-box">
						<div className="input-box" id="box-aluno">
							<p>
								Data inicio da turma<span id="ob">*</span>
							</p>
							<DatePicker
								disabled={turma.vigencia ? false : true}
								className="w-100"
								value={turma.dataInicio ? moment(turma.dataInicio) : null}
								onChange={(date) => {
									if (date) {
										setTurma({
											...turma,
											dataInicio: date.toDate(),
											dataFim: date.add(turma.vigencia?.dias, 'days').toDate(),
										});
									}
								}}
								format={'DD-MM-YYYY'}
								placeholder="Data de Início"
							/>
						</div>
						<div className="input-box" id="box-aluno">
							<p>
								Data fim<span id="ob">*</span>
							</p>
							<DatePicker
								disabled={true}
								className="w-100"
								value={turma.dataFim ? moment(turma.dataFim) : null}
								format={'DD-MM-YYYY'}
								placeholder="Data de Fim"
							/>
						</div>
					</div>
					<div className="input-box">
						<p>Periodicidade da aula</p>
						<span> {(negocioSelected?.periodoSemana != null ? negocioSelected?.periodoSemana : 0) + ' períodos'}</span>
						<span> {(negocioSelected?.duracaoAula != null ? negocioSelected?.duracaoAula : 0) + ' min'}</span>
					</div>

					<div className="input-box">
						<p>
							Horário<span id="ob">*</span>
						</p>
						{turma.horarios && turma.horarios.map((hora, index) => (
							<div key={index}>
								{index === 0 && !negocioSelected?.periodicidadeObrigatoria && !hora.horaFim ? (
									!turma?.curriculoNegocioId ? (
										<p style={{ color: '#ff4d4f' }}>Selecione um negócio para adicionar horários</p>
									) : (
										<div style={{ display: 'flex', flexDirection: 'row' }}>
											<Select 
												value={hora.codigo} 
												onChange={(e) => {
													setTurma((prev) => ({
														...prev,
														horarios: prev.horarios.map((h, i) => 
															i === 0 
																? { ...h, codigo: e as IDiaSemana }
																: h
														)
													}));
												}}
												placeholder="Selecione o dia"
											>
												{WEEK_DAYS_ACRONYMS.map((dia) => (
													<Select.Option key={dia} value={dia}>
														{dia}
													</Select.Option>
												))}
											</Select>
											<TimePicker 
												value={hora.horaInicio ? moment(hora.horaInicio, horarioFormat) : null}
												onChange={(time) => {
													setTurma((prev) => ({
														...prev,
														horarios: prev.horarios.map((h, i) => 
															i === 0 
																? { ...h, horaInicio: time?.format(horarioFormat) }
																: h
														)
													}));
												}}
												format={horarioFormat}
												allowClear
												minuteStep={15}
											/>
											<TimePicker 
												value={hora.horaFim ? moment(hora.horaFim, horarioFormat) : null}
												onChange={(time) => {
													setTurma((prev) => ({
														...prev,
														horarios: prev.horarios.map((h, i) => 
															i === 0 
																? { ...h, horaFim: time?.format(horarioFormat) }
																: h
														)
													}));
												}}
												format={horarioFormat}
												minuteStep={15}
											/>
											<Button 
												onClick={() => {
													if (!hora.horaFim) {
														notification({
															description: 'Por favor, preencha a hora final',
															type: 'warning',
															message: 'Aviso!',
														});
														return;
													}
													onConfirmarHorario(hora.horaInicio + '-' + hora.horaFim, hora.codigo as IDiaSemana)
												}}
											>
												Confirmar
											</Button>
										</div>
									)
								) : (
									<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
										<p>{hora.codigo + ' - ' + hora.horaInicio + ' às ' + (hora.horaFim || '')}</p>
										<a 
											onClick={() => {
												setTurma((prev) => ({
													...prev,
													horarios: prev.horarios.filter((_, i) => i !== index)
												}));
												setDia(hora.codigo as IDiaSemana);
												setNovaHora(moment(hora.horaInicio, horarioFormat));
												setNovaHoraFim(moment(hora.horaFim, horarioFormat));
												setAdicionarHorario(true);
											}}
											style={{ cursor: 'pointer' }}
										>
											<Unicons.UilEdit hidden={turma?.id} size="20" color="#92A9CB" />
										</a>
									</div>
								)}
							</div>
						))}
						{adicionarHorario === true && (
							<div style={{ display: 'flex', flexDirection: 'row' }}>
								<Select onChange={(e) => setDia(e as IDiaSemana)} placeholder="Selecione o dia">
									{WEEK_DAYS_ACRONYMS.map((dia) => (
										<Select.Option key={dia} value={dia}>
											{dia}
										</Select.Option>
									))}
								</Select>
								<TimePicker onChange={(e) => setNovaHora(e)} value={novaHora} format={horarioFormat} allowClear minuteStep={15} />
								<TimePicker onChange={(e) => setNovaHoraFim(e)} disabled={negocioSelected?.periodicidadeObrigatoria} value={novaHoraFim} format={horarioFormat} minuteStep={15}/>
								<Button onClick={() => {
									if (!novaHora || !novaHoraFim) {
										notification({
											description: 'Por favor, preencha tanto a hora inicial quanto a hora final',
											type: 'warning',
											message: 'Aviso!',
										});
										return;
									}
									onConfirmarHorario(novaHora?.format(horarioFormat) + '-' + novaHoraFim?.format(horarioFormat), dia)
								}}>Confirmar</Button>
							</div>
						)}
						{shouldShowAddCurriculumHours() && !turma?.curriculoNegocioId && (
							<p style={{ color: '#ff4d4f' }}>Selecione um negócio para adicionar horários</p>
						)}
						{shouldShowAddCurriculumHours() && !turma?.id && turma?.curriculoNegocioId && <AddCurriculumHours onClick={() => setAdicionarHorario(true)} />}
					</div>

					<div className="botoes">
						<Link to="/turmas">
							<Button className="button-second" onClick={() => editBtnIsVisible(false)} style={{ width: 345 }}>
								Cancelar
							</Button>
						</Link>
						<div>
							<Button onClick={validaCamposObrigatorios} className="button-primary" style={{ width: 345 }}>
								Proximo
							</Button>
						</div>
					</div>
				</div>
			</div>
			<Button onClick={() => setIsOpen(true)} className="button-fechar" icon={<CloseOutlined rev={undefined} />} />
			<Modal
				open={isOpen}
				onClose={() => setIsOpen(false)}
				title="Você deseja cancelar a adição desta Nova turma?"
				subtitle="Todos os dados serão perdidos, e essa ação não pode ser desfeita."
				textButton1="Não"
				textButton2="Sim, Cancelar"
				styleButton1="button-line"
				styleButton2="button-danger"
				link2="/turmas"
			/>
		</div>
	);
};
